module.exports = __webpack_public_path__ + "img/oximetry.5c7e9962.svg";